import React, {useState, useEffect} from 'react'
import { FormattedDate } from './../components/FormattedDate'
import { authFetch } from '../api/authFetch'
import InlineAlert from './../components/InlineAlert'

export default function Notifications() {
    const [notifications, setNotifications] = useState([])
    const [loading, setLoading] = useState(true)
    const [loadError, setLoadError] = useState(null)
    const [page, setPage] = useState(1)
    const [totalPages, setTotalPages] = useState(1)
    // const [search, setSearch] = useState('')
    // const [expandedChatId, setExpandedChatId] = useState(null)

    useEffect(() => {
        fetchNotifications()
    }, [page])

    const fetchNotifications = async () => {
        setLoading(true)
        setLoadError(null)
        try {
            const params = new URLSearchParams({page, limit: 20})
            // if (search) params.append('search', search)

            const res = await authFetch(`/api/notifications?${params}`)
            const data = await res.json()
            if (!res.ok) {
                throw new Error(data.error || res.statusText || 'Failed to load notifications')
            }
            setNotifications(data.notifications || [])
            setTotalPages(data.totalPages || 1)
        } catch (err) {
            console.error('Failed to fetch notifications:', err)
            setLoadError(err.message || 'Failed to load notifications')
        } finally {
            setLoading(false)
        }
    }

    return (
        <div>
            <h1 className="text-2xl font-bold text-gray-900 mb-6">Notifications</h1>

            {loadError && (
                <InlineAlert variant="error" onDismiss={() => setLoadError(null)}>
                    <p>{loadError}</p>
                </InlineAlert>
            )}

            {/* Table */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                {loading ? (
                    <div className="flex items-center justify-center h-64">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
                    </div>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="w-full">
                            <thead className="bg-gray-50 border-b border-gray-200">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Sent at</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Created At</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Chat ID</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Slot ID</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Job ID</th>
                            </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200">
                            {notifications.map((notification) => (
                                    <tr key={notification.id} className="hover:bg-gray-50">
                                        <td className="px-6 py-4 text-sm text-gray-500">
                                            {notification.isSent ? (
                                                <span className="text-green-500">✅&nbsp;
                                                    <FormattedDate isoDate={notification.updatedAt} />
                                                </span>
                                            ) : (
                                                <span className="text-yellow-500">❌&nbsp;Not sent yet</span>
                                            )}
                                        </td>
                                        <td className="px-6 py-4 text-sm text-gray-500">
                                            <FormattedDate isoDate={notification.createdAt} />
                                        </td>
                                        <td className="px-6 py-4 text-sm text-gray-900">{notification.chatId}</td>
                                        <td className="px-6 py-4 text-sm text-gray-900 font-mono text-xs">{notification.slotId}</td>
                                        <td className="px-6 py-4 text-sm text-gray-900">{notification.jobId}</td>
                                    </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                )}

                {/* Pagination */}
                <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between">
                    <p className="text-sm text-gray-500">Page {page} of {totalPages}</p>
                    <div className="flex gap-2">
                        <button
                            onClick={() => setPage(p => Math.max(1, p - 1))}
                            disabled={page === 1}
                            className="px-4 py-2 border border-gray-300 rounded-lg text-sm disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
                        >
                            Previous
                        </button>
                        <button
                            onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                            disabled={page === totalPages}
                            className="px-4 py-2 border border-gray-300 rounded-lg text-sm disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
                        >
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
